import { render, staticRenderFns } from "./ModifierList.vue?vue&type=template&id=0a5b21d2&"
import script from "./ModifierList.vue?vue&type=script&lang=js&"
export * from "./ModifierList.vue?vue&type=script&lang=js&"
import style0 from "./ModifierList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports